import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  RouteLocationNormalizedLoaded
} from "vue-router";
import { watch } from "vue";
import { useVersao } from "../modules/versao";
import Home from "../views/Home.vue";
import AcessoNegado from "../views/AcessoNegado.vue";
import Engenheiro from "../views/engenheiro/Engenheiro.vue";
import Orcamento from "../views/orcamento/Orcamento.vue";
import TabelaPreco from "../views/orcamento/TabelaPreco.vue";
import ContratoTransportador from "../views/orcamento/ContratoTransportador.vue";
import Dashboard from "../views/cliente/Dashboard.vue";
import RobosFilas from "../views/cliente/RobosFilas.vue";
import Cliente from "../views/cliente/Cliente.vue";
import ClienteAdmin from "../views/cliente/ClienteAdmin.vue";
import Tenant from "../views/cliente/Tenant.vue";
import Transportador from "../views/transportador/Transportador.vue";
import PlanilhaTrechos from "../views/trecho/PlanilhaTrechos.vue";
import ModeloVeiculoTrator from "../views/veiculo/ModeloVeiculoTrator.vue";
import Carreta from "../views/veiculo/Carreta.vue";
import Licenca from "../views/licenca/Licenca.vue";
import CombinacaoVeiculo from "../views/licenca/CombinacaoVeiculo.vue";
import Faturamento from "../views/licenca/Faturamento.vue";
import VeiculoTrator from "../views/veiculo/VeiculoTrator.vue";
import ImportacaoVeiculo from "../views/veiculo/ImportacaoVeiculo.vue";
import Login from "../views/auth/Login.vue";
import Logout from "../views/auth/Logout.vue";
import TurnstileChallenge from "../views/auth/TurnstileChallenge.vue";
import ChangeMyPassword from "../views/auth/ChangeMyPassword.vue";
import ChangePasswordWithToken from "../views/auth/ChangePasswordWithToken.vue";
import RequestRecover from "../views/auth/RequestRecover.vue";
import {
  useAuth,
  TURNSTILE_VERIFIED,
  TURNSTILE_ENABLED
} from "../modules/auth";
import { useFeature } from "../modules/feature";
import { useToast } from "../modules/message";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    meta: {
      authenticated: true
    },
    component: Home
  },
  {
    path: "/me/password",
    name: "me-change-password",
    meta: {
      authenticated: true
    },
    component: ChangeMyPassword
  },
  {
    path: "/root/dashboard",
    name: "root-dashboard",
    component: Dashboard
  },
  {
    path: "/root/robos-filas",
    name: "root-robos-filas",
    meta: {
      securityKey: "root-dashboard"
    },
    component: RobosFilas
  },
  {
    path: "/root/cliente",
    name: "root-cliente",
    component: Cliente
  },
  {
    path: "/root/cliente/:idCliente",
    name: "root-cliente-edit",
    meta: {
      securityKey: "root-cliente",
      authority: "edit"
    },
    component: Cliente,
    props(route) {
      const idCliente: number = +route.params.idCliente;
      return { idCliente: idCliente };
    }
  },
  {
    path: "/root/tenant",
    name: "root-tenant",
    component: Tenant
  },
  {
    path: "/admin/cliente",
    name: "admin-cliente",
    component: ClienteAdmin
  },
  {
    path: "/usuario",
    name: "usuario",
    component: Home
  },
  {
    path: "/veiculo/trator/modelo",
    name: "veiculo-trator-modelo",
    component: ModeloVeiculoTrator
  },
  {
    path: "/veiculo/trator/modelo/:idModeloVeiculoTrator",
    name: "veiculo-trator-modelo-edit",
    meta: {
      securityKey: "veiculo-trator-modelo",
      authority: "edit"
    },
    component: ModeloVeiculoTrator,
    props(route) {
      const idModeloVeiculoTrator: number = +route.params.idModeloVeiculoTrator;
      return { idModeloVeiculoTrator: idModeloVeiculoTrator };
    }
  },
  {
    path: "/veiculo/trator/modelo/novo",
    name: "veiculo-trator-modelo-new",
    meta: {
      securityKey: "veiculo-trator-modelo",
      authority: "create"
    },
    component: ModeloVeiculoTrator,
    props: {
      isNew: true
    }
  },
  {
    path: "/veiculo/trator/modelo/copia/:idModeloVeiculoTratorCopy",
    name: "veiculo-trator-modelo-copy",
    meta: {
      securityKey: "veiculo-trator-modelo",
      authority: "create"
    },
    component: ModeloVeiculoTrator,
    props(route) {
      const idModeloVeiculoTratorCopy: number = +route.params
        .idModeloVeiculoTratorCopy;
      return {
        isNew: true,
        idModeloVeiculoTratorCopy: idModeloVeiculoTratorCopy
      };
    }
  },
  {
    path: "/veiculo/trator",
    name: "veiculo-trator",
    component: VeiculoTrator
  },
  {
    path: "/veiculo/trator/:idVeiculoTrator",
    name: "veiculo-trator-edit",
    meta: {
      securityKey: "veiculo-trator",
      authority: "edit"
    },
    component: VeiculoTrator,
    props(route) {
      const idVeiculoTrator: number = +route.params.idVeiculoTrator;
      return { idVeiculoTrator: idVeiculoTrator };
    }
  },
  {
    path: "/veiculo/trator/novo",
    name: "veiculo-trator-new",
    meta: {
      securityKey: "veiculo-trator",
      authority: "create"
    },
    component: VeiculoTrator,
    props: {
      isNew: true
    }
  },
  {
    path: "/veiculo/carreta",
    name: "carreta",
    component: Carreta
  },
  {
    path: "/veiculo/carreta/:idCarreta",
    name: "carreta-edit",
    meta: {
      securityKey: "carreta",
      authority: "edit"
    },
    component: Carreta,
    props(route) {
      const idCarreta: number = +route.params.idCarreta;
      return { idCarreta: idCarreta };
    }
  },
  {
    path: "/veiculo/carreta/novo",
    name: "carreta-new",
    meta: {
      securityKey: "carreta",
      authority: "create"
    },
    component: Carreta,
    props: {
      isNew: true
    }
  },
  {
    path: "/veiculo/importacao-lote",
    name: "veiculo-importacao-lote",
    component: ImportacaoVeiculo
  },
  {
    path: "/transportador",
    name: "transportador",
    component: Transportador
  },
  {
    path: "/transportador/:idTransportador",
    name: "transportador-edit",
    meta: {
      securityKey: "transportador",
      authority: "edit"
    },
    component: Transportador,
    props(route) {
      const idTransportador: number = +route.params.idTransportador;
      return { idTransportador: idTransportador };
    }
  },
  {
    path: "/transportador/novo",
    name: "transportador-new",
    meta: {
      securityKey: "transportador",
      authority: "create"
    },
    component: Transportador,
    props: {
      isNew: true
    }
  },
  {
    path: "/engenheiro",
    name: "engenheiro",
    component: Engenheiro
  },
  {
    path: "/engenheiro/novo",
    name: "engenheiro-new",
    meta: {
      securityKey: "engenheiro",
      authority: "create"
    },
    component: Engenheiro,
    props: {
      isNew: true
    }
  },
  {
    path: "/engenheiro/:idEngenheiro",
    name: "engenheiro-edit",
    meta: {
      securityKey: "engenheiro",
      authority: "edit"
    },
    component: Engenheiro,
    // Guard: evita que um :idEngenheiro nao numerico (ex.: "art") seja repassado a API,
    // o que gerava chamadas GET /engenheiro/art em loop. Redireciona para a listagem.
    beforeEnter: (to, from, next) => {
      if (!/^\d+$/.test(String(to.params.idEngenheiro))) {
        next({ name: "engenheiro" });
      } else {
        next();
      }
    },
    props(route) {
      const idEngenheiro: number = +route.params.idEngenheiro;
      return { idEngenheiro: idEngenheiro };
    }
  },
  {
    path: "/licenca",
    name: "licenca",
    component: Licenca
  },
  {
    path: "/licenca/novo",
    name: "licenca-new",
    meta: {
      securityKey: "licenca",
      authority: "create"
    },
    component: Licenca,
    props: {
      isNew: true
    }
  },
  {
    path: "/licenca/:idLicenca",
    name: "licenca-edit",
    meta: {
      securityKey: "licenca",
      authority: "edit"
    },
    component: Licenca,
    props(route) {
      const idLicenca: number = +route.params.idLicenca;
      return { idLicenca: idLicenca };
    }
  },
  {
    path: "/licenca/copia/:idLicencaCopy",
    name: "licenca-copy",
    meta: {
      securityKey: "licenca",
      authority: "create"
    },
    component: Licenca,
    props(route) {
      const idLicencaCopy: number = +route.params.idLicencaCopy;
      return {
        isNew: true,
        idLicencaCopy: idLicencaCopy
      };
    }
  },
  {
    path: "/licenca/combinacao-veiculos",
    name: "licenca-combinacao-veiculos",
    component: CombinacaoVeiculo
  },
  {
    path: "/trechos/planilha",
    name: "trechos-planilha",
    component: PlanilhaTrechos
  },
  {
    path: "/trechos/planilha/novo",
    name: "trechos-planilha-new",
    meta: {
      securityKey: "trechos-planilha",
      authority: "create"
    },
    component: PlanilhaTrechos,
    props: {
      isNew: true
    }
  },
  {
    path: "/trechos/planilha/:idPlanilhaTrechos",
    name: "trechos-planilha-edit",
    meta: {
      securityKey: "trechos-planilha",
      authority: "edit"
    },
    component: PlanilhaTrechos,
    props(route) {
      const idPlanilhaTrechos: number = +route.params.idPlanilhaTrechos;
      return { idPlanilhaTrechos: idPlanilhaTrechos };
    }
  },
  {
    path: "/trechos/planilha/copia/:idPlanilhaTrechosCopy",
    name: "trechos-planilha-copy",
    meta: {
      securityKey: "trechos-planilha",
      authority: "create"
    },
    component: PlanilhaTrechos,
    props(route) {
      const idPlanilhaTrechosCopy: number = +route.params.idPlanilhaTrechosCopy;
      return {
        isNew: true,
        idPlanilhaTrechosCopy: idPlanilhaTrechosCopy
      };
    }
  },
  {
    path: "/relatorio/faturamento",
    name: "relatorio-faturamento",
    component: Faturamento
  },
  {
    path: "/challenge",
    name: "challenge",
    component: TurnstileChallenge,
    meta: { open: true }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { open: true }
  },
  {
    path: "/login/recover/request",
    name: "recover-request",
    component: RequestRecover,
    meta: { open: true }
  },
  {
    path: "/login/recover/:token",
    name: "recover",
    component: ChangePasswordWithToken,
    meta: { open: true },
    props(route) {
      const token: string = Array.isArray(route.params.token)
        ? route.params.token[0]
        : route.params.token;
      return {
        token: token,
        withToken: true
      };
    }
  },
  {
    path: "/login/new/:token",
    name: "login-new",
    component: ChangePasswordWithToken,
    meta: { open: true },
    props(route) {
      const token: string = Array.isArray(route.params.token)
        ? route.params.token[0]
        : route.params.token;
      return {
        token: token
      };
    }
  },
  {
    path: "/orcamento",
    name: "orcamento",
    meta: {
      securityKey: "orcamento",
      authority: "view"
    },
    component: Orcamento
  },
  {
    path: "/orcamento/novo",
    name: "orcamento-new",
    meta: {
      securityKey: "orcamento",
      authority: "create"
    },
    component: Orcamento,
    props: {
      isNew: true
    }
  },
  {
    path: "/orcamento/:idOrcamento",
    name: "orcamento-edit",
    meta: {
      securityKey: "orcamento",
      authority: "edit"
    },
    component: Orcamento,
    props(route) {
      const idOrcamento: number = +route.params.idOrcamento;
      return { idOrcamento: idOrcamento };
    }
  },
  {
    path: "/tabela-preco",
    name: "tabela-preco",
    meta: {
      securityKey: "tabela-preco",
      authority: "view"
    },
    component: TabelaPreco
  },
  {
    path: "/tabela-preco/novo",
    name: "tabela-preco-new",
    meta: {
      securityKey: "tabela-preco",
      authority: "create"
    },
    component: TabelaPreco,
    props: {
      isNew: true
    }
  },
  {
    path: "/tabela-preco/:idTabelaPreco",
    name: "tabela-preco-edit",
    meta: {
      securityKey: "tabela-preco",
      authority: "edit"
    },
    component: TabelaPreco,
    props(route) {
      const idTabelaPreco: number = +route.params.idTabelaPreco;
      return { idTabelaPreco: idTabelaPreco };
    }
  },
  {
    path: "/contrato-transportador",
    name: "contrato-transportador",
    meta: {
      securityKey: "contrato-transportador",
      authority: "view"
    },
    component: ContratoTransportador
  },
  {
    path: "/contrato-transportador/novo",
    name: "contrato-transportador-new",
    meta: {
      securityKey: "contrato-transportador",
      authority: "create"
    },
    component: ContratoTransportador,
    props: {
      isNew: true
    }
  },
  {
    path: "/contrato-transportador/:idContratoTransportador",
    name: "contrato-transportador-edit",
    meta: {
      securityKey: "contrato-transportador",
      authority: "edit"
    },
    component: ContratoTransportador,
    props(route) {
      const idContratoTransportador: number = +route.params
        .idContratoTransportador;
      return { idContratoTransportador: idContratoTransportador };
    }
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authenticated: true
    },
    component: Logout
  },
  {
    path: "/acesso-negado",
    name: "acesso-negado",
    meta: {
      authenticated: true
    },
    component: AcessoNegado
  },
  {
    path: "/*",
    redirect: "/",
    meta: {
      open: true
    }
  }
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// versao nova publicada: a troca de tela vira um carregamento completo do destino, que traz o
// bundle novo sem perder nada (o usuario ja estava saindo da tela). Ver modules/versao.ts.
router.beforeEach((to, from, next) => {
  const { novaVersao, recarregar } = useVersao();
  if (
    novaVersao.value &&
    from.matched.length &&
    to.fullPath !== from.fullPath
  ) {
    recarregar(router.resolve(to).href);
    next(false);
    return;
  }
  next();
});

const { authenticating, user, reloadUser } = useAuth();

router.beforeEach((to, from, next) => {
  const processRoutes = () => {
    if (!to.meta.open) {
      if (user?.value) {
        if (TURNSTILE_ENABLED && !sessionStorage.getItem(TURNSTILE_VERIFIED)) {
          next({ name: "challenge", query: { redirect: to.fullPath } });
          return;
        }
        const authority: string =
          to.meta.authority && typeof to.meta.authority == "string"
            ? to.meta.authority
            : "view";
        const key: string | undefined =
          to.meta.securityKey && typeof to.meta.securityKey == "string"
            ? to.meta.securityKey
            : to.name?.toString();
        const requiredFeature: number | undefined =
          typeof to.meta.feature === "number" ? to.meta.feature : undefined;

        if (!to.meta.authenticated && !useAuth().amIAllowed(authority, key)) {
          useToast().warning("Acesso invalido, redirecionando para home.");
          next({ name: "home" });
        } else if (
          requiredFeature !== undefined &&
          !useFeature().isFeatureHabilitada(requiredFeature)
        ) {
          next({ name: "acesso-negado" });
        } else if (to.name === "home") {
          if (useAuth().amIAllowed("view", "root-dashboard")) {
            next({ name: "root-dashboard" });
          } else {
            next({ name: "licenca" });
          }
        } else {
          const currUser = user.value.idUsuario;
          reloadUser().then((user) => {
            if (currUser !== user.idUsuario) {
              useToast().warning(
                "Detectada alteração de usuário, redirecionando para home."
              );
              next({ name: "home" });
            } else if (!user.termosUso && to.name !== "admin-cliente") {
              //Redirecionado para finalizar dados cadastrais
              next({ name: "admin-cliente" });
            } else {
              next();
            }
          });
        }
      } else if (authenticating.value === false) {
        useToast().info("Realize o login para acessar o sistema.");
        next({ name: "login" });
      } else {
        next();
      }
    } else {
      next();
    }
  };

  if (authenticating.value === false) {
    processRoutes();
  } else {
    const unwatch = watch([authenticating], () => {
      if (authenticating.value === false) {
        unwatch();
        processRoutes();
      }
    });
  }
});

reloadUser();

export default router;

export interface MenuEvent {
  originalEvent?: PointerEvent;
  item?: MenuModel;
}
/* eslint-disable  @typescript-eslint/no-explicit-any */
export interface MenuModel {
  label?: string;
  icon?: string;
  separator?: boolean;
  items?: Array<MenuModel>;
  to?: Partial<RouteLocationNormalizedLoaded>;
  command?: (event?: MenuEvent) => any;
  disabled?: boolean;
}
